var map = {
	"./anonymous.svg": [
		79305,
		79305
	],
	"./bronze.svg": [
		55606,
		55606
	],
	"./casanova.svg": [
		66256,
		66256
	],
	"./crush.svg": [
		12463,
		12463
	],
	"./diamond.svg": [
		6914,
		6914
	],
	"./eros.gif": [
		78734,
		78734
	],
	"./gold.svg": [
		51700,
		51700
	],
	"./lancelot.svg": [
		61876,
		61876
	],
	"./lover.svg": [
		34868,
		34868
	],
	"./platinum.svg": [
		65974,
		65974
	],
	"./romeo.svg": [
		39804,
		39804
	],
	"./secret.svg": [
		49418,
		49418
	],
	"./signature.svg": [
		13628,
		13628
	],
	"./silver.svg": [
		98881,
		98881
	],
	"./sweetheart.svg": [
		38654,
		38654
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 95570;
module.exports = webpackAsyncContext;